"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPaymentStatusUI = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("./components");
var CardPaymentStatusUI = function (_a) {
    var status = _a.status, txId = _a.txId, amount = _a.amount;
    return (react_1.default.createElement("section", null, status === 'success' ? (react_1.default.createElement(components_1.Success, { txId: txId, amount: amount })) : status === 'cancelled' ? (react_1.default.createElement(components_1.Cancelled, { amount: amount })) : status === 'pending' ? (react_1.default.createElement(components_1.Pending, null)) : (react_1.default.createElement(components_1.Error, null))));
};
exports.CardPaymentStatusUI = CardPaymentStatusUI;
